import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "filename"]

  dragover(event) {
    event.preventDefault()
    this.element.classList.add("border-2", "border-dashed", "!border-[#356666]", "!bg-[#e8f4f4]")
  }

  dragleave(event) {
    if (!this.element.contains(event.relatedTarget)) {
      this.element.classList.remove("border-2", "border-dashed", "!border-[#356666]", "!bg-[#e8f4f4]")
    }
  }

  drop(event) {
    event.preventDefault()
    this.element.classList.remove("border-2", "border-dashed", "!border-[#356666]", "!bg-[#e8f4f4]")
    const files = event.dataTransfer.files
    if (files.length > 0) {
      this.inputTarget.files = files
      this.#showFilename(files[0].name)
    }
  }

  fileSelected() {
    const file = this.inputTarget.files[0]
    if (file) this.#showFilename(file.name)
  }

  #showFilename(name) {
    this.filenameTarget.textContent = name
  }
}
